import React, { Fragment, useCallback, useEffect, useState } from 'react';

import Button from '../Button/Button';
import ButtonWrapper from '../Button/ButtonWrapper';
import ClaimButtonWrapper from './ClaimButtonWrapper';
import CreateClaimWrapper from '../layout/CreateClaimWrapper';

import CheckboxField from '../form/CheckboxField';
import TextareaField from '../form/TextareaField';
import LabelField from '../form/LabelField';
import FileUploaderField from '../form/FileUploadeField';
import { FieldsNames, radioValues, ReturnFormData } from '../../types/Form';

import 'twin.macro';
import GrayBackgroundWrapper from '../layout/GrayBackgroundWrapper';
import LeftArrow from '../icons/LeftArrow';
import RadioField from '../form/RadioField';
import { containsOnlyNumbers } from '../../utils/stringFormatters';
import useQuery from '../../hooks/use-query-hook';
import useAuthRedirect from '../../hooks/use-auth-redirect-hook';
import routePaths from '../../route-paths';
import { isMobile, isTablet } from 'react-device-detect';

const MAX_FILES_SIZE = 30000000;

interface Props {
  initialData: ReturnFormData | null;
  handleSaveData: (data: ReturnFormData) => void;
  awbNumbers?: string;
  moneyTransferNumbers?: string;
  errorMessagesOnSubmit?: Array<string>;
  clearErrorsOnSubmit: Function;
  goBack: Function;
  setFail?: Function;
  touched: boolean;
  shouldRestartData?: boolean;
}

const initialState: ReturnFormData = {
  [FieldsNames.Checkbox1]: false,
  [FieldsNames.Checkbox2]: false,
  [FieldsNames.Checkbox3]: false,
  [FieldsNames.Checkbox4]: false,
  [FieldsNames.Claimer]: 'sender',
  [FieldsNames.RegardingShipment]: '',
  [FieldsNames.Other]: '',
  [FieldsNames.Files]: [],
};

interface ErrorsValidation {
  [key: string]: string;
}

interface Validation {
  errors: ErrorsValidation;
  isValid: boolean;
}

const validateFields = (
  values: ReturnFormData,
  awbNumbers: string | undefined,
  moneyTransferNumbers: string | undefined,
  errorMessagesOnSubmit?: Array<string>,
  setFail?: Function
): Validation => {
  const errors: ErrorsValidation = {};

  if (errorMessagesOnSubmit && errorMessagesOnSubmit.length > 0 && errorMessagesOnSubmit[0]) {
    errorMessagesOnSubmit.forEach((err) => {
      let error = err;
      if (error.includes('вече има заведена')) error = 'вече има заведена';
      if (error.includes('6 месеца')) error = '6 месеца';

      switch (error) {
        case 'Не са открити товарителници или преводи с посочените номера.': {
          errors[FieldsNames.RegardingShipment] =
            'Не са открити товарителници или преводи с посочените номера.';
          break;
        }
        case 'вече има заведена': {
          errors[FieldsNames.RegardingShipment] =
            'Вече има заведена рекламация по услугата, моля проверете статуса й.';
          break;
        }
        case '6 месеца': {
          errors[FieldsNames.RegardingShipment] = errorMessagesOnSubmit as any;
          break;
        }
        default:
          if (setFail) {
            setFail('Поради техническа грешка не успяхме да получим рекламацията.');
          }
          break;
      }
    });
  }

  if (
    !values[FieldsNames.Checkbox1] &&
    !values[FieldsNames.Checkbox2] &&
    !values[FieldsNames.Checkbox3] &&
    values[FieldsNames.Checkbox4]
  ) {
    if (
      !values[FieldsNames.RegardingShipment] &&
      !containsOnlyNumbers(values[FieldsNames.RegardingShipment])
    ) {
      errors[FieldsNames.RegardingShipment] =
        'Моля, въведете правилен номер на пратка (товарителница). Ако имате повече от един, ги разделете със запетая или поставете всеки на нов ред.';
    }
  } else if (!containsOnlyNumbers(values[FieldsNames.RegardingShipment]))
    errors[FieldsNames.RegardingShipment] =
      'Моля, въведете правилен номер на пратка (товарителница). Ако имате повече от един, ги разделете със запетая или поставете всеки на нов ред.';

  if (values[FieldsNames.RegardingShipment]) {
    const createArrayFromValues = values[FieldsNames.RegardingShipment]?.split(',');

    const toFindDuplicates = (arry: any) =>
      arry.filter((item: any, index: number) => arry.indexOf(item) !== index);
    const duplicateElements = toFindDuplicates(createArrayFromValues);

    if (duplicateElements && duplicateElements.length) {
      errors[FieldsNames.RegardingShipment] = 'Въвели сте повтарящ се номер, моля коригирайте.';
    }
  }

  if (!values[FieldsNames.Claimer]) {
    errors[FieldsNames.Claimer] = 'Моля, изберете кой ще следи рекламацията.';
  }

  if (
    !values[FieldsNames.Checkbox1] &&
    !values[FieldsNames.Checkbox2] &&
    !values[FieldsNames.Checkbox3] &&
    !values[FieldsNames.Checkbox4]
  ) {
    errors[FieldsNames.Checkbox1] = 'Моля, изберете причина за рекламация.';
  }

  const files = values[FieldsNames.Files];
  if (files.length > 5) {
    errors[FieldsNames.Files] = 'Имате право да качите 5 файла.';
  }

  if (files) {
    let totalSize = 0;
    files.forEach((item) => {
      totalSize += item.file.size;
    });

    if (totalSize > MAX_FILES_SIZE) {
      errors[FieldsNames.Files] = 'Максималния размер на всички файлове е 30 МБ';
    }
  }

  // if (values[FieldsNames.Checkbox1] && !awbNumbers && !moneyTransferNumbers) {
  //   if (!values[FieldsNames.Other]) {
  //     errors[FieldsNames.Other] = 'Моля, опишете причината за рекламация.';
  //   }
  // }

  if (values[FieldsNames.Checkbox2]) {
    if (!values[FieldsNames.Other]) {
      errors[FieldsNames.Other] = 'Моля, опишете причината за рекламация.';
    }

    if (files.length === 0) {
      errors[FieldsNames.Files] = 'Моля, качете поне 1 файл.';
    }
  }

  if (values[FieldsNames.Checkbox3]) {
    if (files.length === 0) {
      errors[FieldsNames.Files] = 'Моля, качете поне 1 файл.';
    }
  }

  if (values[FieldsNames.Checkbox4]) {
    if (!values[FieldsNames.Other]) {
      errors[FieldsNames.Other] = 'Моля, опишете причината за рекламация.';
    }
  }

  if (values && values[FieldsNames.Other] && values[FieldsNames.Other].length < 10) {
    errors[FieldsNames.Other] = 'Моля, въведи текст, който да съдържа поне 10 символа.';
  }

  console.log(errors);

  const isValid = Object.keys(errors).length > 0;

  return {
    errors,
    isValid,
  };
};

const ReturnForm = ({
  initialData,
  handleSaveData,
  awbNumbers,
  moneyTransferNumbers,
  errorMessagesOnSubmit,
  clearErrorsOnSubmit,
  goBack,
  setFail,
  touched,
  shouldRestartData,
}: Props) => {
  const [values, setValue] = useState<ReturnFormData>(initialData || initialState);
  const [isTouched, setTouched] = useState<boolean>(touched);

  const { errors, isValid } = validateFields(
    values,
    awbNumbers,
    moneyTransferNumbers,
    errorMessagesOnSubmit,
    setFail
  );

  const queryParameters = useQuery();
  const { onRedirect } = useAuthRedirect();

  useEffect(() => {
    if (queryParameters) {
      const { awbNumbers, sourceApp, shipmentNumber, preparedShipment } = queryParameters;
      if (awbNumbers) {
        setValue({
          ...values,
          regardingShipment: awbNumbers,
        });
      }

      if (
        (sourceApp === 'mobileAppEcont' || sourceApp === 'webAppEcont') &&
        shipmentNumber &&
        preparedShipment
      ) {
        setValue({
          ...values,
          regardingShipment: shipmentNumber,
          [FieldsNames.Checkbox4]: true,
          claimer: 'sender',
        });
      } else if (
        (sourceApp === 'mobileAppEcont' || sourceApp === 'webAppEcont') &&
        shipmentNumber
      ) {
        setValue({
          ...values,
          regardingShipment: shipmentNumber,
          [FieldsNames.Checkbox1]: true,
          claimer: 'sender',
        });
      }
    }
  }, []);

  useEffect(() => {
    if (shouldRestartData) {
      setValue(initialData || initialState);
      setTouched(false);
    }
  }, [shouldRestartData]);

  const onSubmit = (event: any) => {
    event.preventDefault();
    if (!isTouched) {
      setTouched(true);
      if (isValid) return;
    }

    if (isValid) return;

    handleSaveData(values);
  };

  const handleInputChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    // @ts-ignore
    const { type, name, checked, value } = e.target;

    if (name === FieldsNames.RegardingShipment) {
      clearErrorsOnSubmit();
    }

    if (
      name === FieldsNames.Checkbox4 ||
      name === FieldsNames.Checkbox1 ||
      name === FieldsNames.Checkbox2 ||
      name === FieldsNames.Checkbox3
    ) {
      const isAnotherCheckboxSelected = values.checkbox1 || values.checkbox2 || values.checkbox3;

      if (!isAnotherCheckboxSelected) {
        if (checked) {
          setValue({
            ...values,
            [name]: checked,
            claimer: 'sender',
          });
        } else {
          setValue({
            ...values,
            [name]: checked,
            claimer: '',
          });
        }

        return;
      }
    }

    const newValue = type === 'checkbox' ? checked : value;
    setValue({
      ...values,
      [name]: newValue,
    });
  };

  const handleFilesChange = useCallback(
    (files: any) => {
      setValue((prevState) => ({
        ...prevState,
        [FieldsNames.Files]: files,
      }));
    },
    [setValue]
  );

  const addComma = awbNumbers && moneyTransferNumbers;

  const serviceNumber = `${awbNumbers || ''}${
    moneyTransferNumbers ? `${addComma ? ', ' : ''} ${moneyTransferNumbers}` : ''
  }`;

  const renderNumbers = () => {
    if (awbNumbers || moneyTransferNumbers) {
      return (
        <div tw='mt-4'>
          <LabelField label='Номер на услуга: ' value={serviceNumber} />
        </div>
      );
    } else return '';
  };

  const handleCancel = () => {
    onRedirect(routePaths.myClaims, queryParameters, queryParameters);
  };

  const renderButtons = () => {
    return (
      <div tw='flex mt-5 justify-between mobile:(flex-col-reverse) tablet:(relative flex-col-reverse items-center) laptop:(flex-row)'>
        <ButtonWrapper>
          <button
            type='button'
            tw='text-blue-500 font-light text-sm font-body mobile:(mt-5) tablet:(mt-5) laptop:(mt-0)'
            onClick={handleCancel}
          >
            Откажи
          </button>
        </ButtonWrapper>
        <ButtonWrapper>
          <Button
            type='submit'
            variant='cool'
            disabled={false}
            width={isMobile || isTablet ? '100%' : ''}
          >
            Подай рекламация
          </Button>
        </ButtonWrapper>
      </div>
    );
  };

  return (
    <form tw='font-body' onSubmit={onSubmit}>
      <GrayBackgroundWrapper />
      <CreateClaimWrapper buttonComponent={<></>}>
        <>
          <div
            className={`flex cursor-pointer ${
              localStorage.getItem('hideHeader') ? 'mt-0' : 'mobile:mt-16 laptop:mt-20'
            }`}
            onClick={() => goBack()}
          >
            <span tw='flex items-center justify-start font-light text-xl font-body text-black-100'>
              <LeftArrow width='24' height='24' fill='rgb(66 66 66)' viewbox='0 0 19 16' />
              Подайте рекламация
            </span>
          </div>
          <div tw='mt-5 p-7 bg-white rounded-lg'>
            {/* {renderNumbers()} */}
            <h3 tw='text-black-light text-base font-semibold font-light'>Изберете причина</h3>

            <div tw='mt-4'>
              <CheckboxField
                label='Липсваща или непълна пратка'
                name={FieldsNames.Checkbox3}
                checked={values[FieldsNames.Checkbox3]}
                onChange={handleInputChange}
              />
            </div>

            <div tw='mt-4'>
              <CheckboxField
                label='Повредена пратка'
                name={FieldsNames.Checkbox2}
                checked={values[FieldsNames.Checkbox2]}
                onChange={handleInputChange}
              />
            </div>

            <div tw='mt-4'>
              <CheckboxField
                label='Забавена доставка'
                name={FieldsNames.Checkbox1}
                checked={values[FieldsNames.Checkbox1]}
                onChange={handleInputChange}
              />
            </div>

            <div tw='mt-4'>
              <CheckboxField
                label='Друго'
                name={FieldsNames.Checkbox4}
                checked={values[FieldsNames.Checkbox4]}
                onChange={handleInputChange}
                error={isTouched ? errors[FieldsNames.Checkbox1] : ''}
              />
            </div>
            {/* {(values[FieldsNames.Checkbox1] ||
              values[FieldsNames.Checkbox2] ||
              values[FieldsNames.Checkbox3]) && (
              <>
                <h3 tw='text-black-light font-light mt-10'>
                  Кой ще следи развитието на рекламацията ?
                </h3>
                <span tw='text-black-light text-[0.9rem] font-light'>
                  Човекът, който ще комуникира с нас и ще получи обезщетение, ако има основание за
                  него.
                </span>
                <div tw='mt-4'>
                  {radioValues.map((radio, index) => (
                    <RadioField
                      key={index}
                      name={FieldsNames.Claimer}
                      label={radio.label}
                      value={radio.value}
                      checked={values[FieldsNames.Claimer] === radio.value}
                      // error={isTouched ? errors[FieldsNames.Claimer] : ''}
                      onChange={handleInputChange}
                      classNameInput={errors[FieldsNames.Claimer] ? '' : ''} // error-radio-field
                    />
                  ))}
              
                </div>
              </>
            )} */}
            <h3 tw='text-black-light font-light mt-5'>Необходима информация</h3>
            {(values[FieldsNames.Checkbox1] ||
              values[FieldsNames.Checkbox2] ||
              values[FieldsNames.Checkbox3] ||
              values[FieldsNames.Checkbox4]) && (
              <div tw='mt-4'>
                <TextareaField
                  name={FieldsNames.RegardingShipment}
                  placeholder={'Въведете номер на пратка/заявка или друго.'}
                  value={values[FieldsNames.RegardingShipment]}
                  error={isTouched ? errors[FieldsNames.RegardingShipment] : ''}
                  onChange={handleInputChange}
                />
              </div>
            )}
            <div tw='mt-4'>
              <TextareaField
                large={true}
                name={FieldsNames.Other}
                placeholder={
                  'Опишете ситуацията в детайли. Например: име на куриер с когото сте се срещнали; дата на получаване или изпращане; адрес и т.н.'
                }
                value={values[FieldsNames.Other]}
                error={isTouched ? errors[FieldsNames.Other] : ''}
                onChange={handleInputChange}
              />
            </div>

            <div tw='mt-4'>
              <FileUploaderField
                // initialFiles={filesMemo}
                value={values[FieldsNames.Files] || []}
                name={FieldsNames.Files}
                onChange={handleFilesChange}
                placeholder='До 5 снимки, кратко видео или документ'
                error={errors[FieldsNames.Files]} // errors[FieldsNames.Files]
              />
            </div>
            <div>{renderButtons()}</div>
          </div>
        </>
      </CreateClaimWrapper>
    </form>
  );
};

export default ReturnForm;
